import _ from 'underscore'

import {
    extractContactAvatar
} from 'util/twistle'

export function contactDetailModelAugmenter(model, orgIdFilter) {
    // figure out orgs you are connected to this person thru
    model.thru_orgs = [];
    model.canStartWorkflow = false;
    model.clickToCallOrgId = false;
    model.showAnalyticsContainer = false;
    model.analyticsOrgIds = [];

    var multipleWorkflowOrgs = false;

    model.avatar = extractContactAvatar(model);

    _.each(model.relationships_info, function(relationship) {
        var org = App.account.getOrgById(relationship.thru_organization);
        if (org){
            if(_.indexOf(model.thru_orgs, org) === -1) {
                model.thru_orgs.push(org);
            }

            if (App.account.isPatient(org)) {
                model.canStartWorkflow = false;
            } else if(!multipleWorkflowOrgs && org.capabilities && org.capabilities.indexOf("w") > -1) {
                model.canStartWorkflow = true;
                model.canViewWorkflowExecutions = true;
                if(model.startWorkflowOrgId) {
                    // if you have multiple relationships, don't restrict to a given org
                    model.startWorkflowOrgId = undefined;
                    multipleWorkflowOrgs = true;
                } else {
                    model.startWorkflowOrgId = org.id;
                }
            }
            if(org.extended_props && org.extended_props.allow_click_to_call)
            {
                model.clickToCallOrgId = org.id;
            }
            if(relationship.analytics)
            {
                model.analyticsOrgIds.push(org.id);
                var relationships = _.filter(model.relationships, function(r){
                    return r !== "org-member" && r !== "teammember";
                });

                if (relationships.length > 0) {
                    model.showAnalyticsContainer = true;
                }
            }
            if (model.isPatient && (
                orgIdFilter === org.id ||
                orgIdFilter === App.account.getEnterpriseOrg()?.id)) {
                // show log viewers from this org, or all orgs if you are viewing at an enterprise level
                let org_clinical_items = org.extended_props?.clinical_data_log_settings || {};
                model.clinical_data_log_items = Object.keys(org_clinical_items).map(
                    k => {
                        return {itemKey: k, organizationId: org.id, ...org_clinical_items[k]}
                    }
                );
                // if you are a certified builder / user admin, you can link to the clinical log viewer
                model.can_view_clinical_log = App.account.canEditFormsAndWorkflows(org.id);
            }
        } else {
            // if you aren't a member of this org, but are viewing this patient in an embedded enterprise view,
            // allow visibility into workflow executions
            if(App.account.getEnterpriseOrg() && App.config.get("providerClientView") === model.username){
                model.canViewWorkflowExecutions = true;
            }
        }
    });

    return model;
}